import { get, post } from "./baseService";

export async function gethomeFilter() {
  const response = await post("course-filter-fields", true);
  return response;
}

export async function getFilterresult(data) {
  var headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  };
  const response = await post("formation-filter", data, headers);
  return response;
}

export async function getCountry(code) {
  const response = await get(`countries/${code}`, true);
  return response;
}
